import useApplicantAssessmentCounters from '../../AiSearch/api/useApplicantAssessmentCounters';
import CandidatesPageHeader from '../../components/CandidatesPageHeader';
import { useCandidatesOverviewContext } from '../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import ImportFromAtsButton from './ImportFromAts/ImportFromAtsButton';
import UIStrings from '@/Utils/UIStrings';

function CandidatesOverviewHeader() {
    const { tabValue, assessmentName, loadPageAsync } = useCandidatesOverviewContext();
    const { mutate: mutateApplicantAssessmentCounters } = useApplicantAssessmentCounters();

    // An import creates candidates behind the page's back, so both the tab counters and the current
    // page of the table are stale the moment it finishes.
    const handleImportCompleted = async () => {
        await Promise.all([mutateApplicantAssessmentCounters(), loadPageAsync()]);
    };

    return (
        <CandidatesPageHeader>
            <div className="flex w-full items-center justify-between gap-4">
                <h2 className="text-secondary-foreground text-2xl leading-tight font-semibold tracking-tight">
                    {UIStrings.CandidateTabsToPageTitle(tabValue)}
                    <span className="font-normal">{` ${UIStrings.For} `}</span>
                    {assessmentName}
                </h2>
                <ImportFromAtsButton onImportCompleted={handleImportCompleted} />
            </div>
        </CandidatesPageHeader>
    );
}

export default CandidatesOverviewHeader;
